import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ScrollContext } from 'react-router-scroll-4';
import { IntlReducer as Intl, IntlProvider } from 'react-redux-multilingual';
import { PersistGate } from 'redux-persist/integration/react';
import './index.scss';

import translations from './constants/translations';
import App from './components/app';
import FullPageLoader from './components/common/fullPageLoader';

// Store
import configureStore from './store';
const { persistor, store } = configureStore();








class Root extends React.Component {
  render() {
    return (
      <Provider store={store}>
        <PersistGate
          loading={<FullPageLoader />}
          persistor={persistor}
          onBeforeLift={() => {
            console.log("Persist loaded");
          }}
        >
          <IntlProvider translations={translations} locale='en'>
            <BrowserRouter basename={'/'}>
              <ScrollContext>
                <App />
              </ScrollContext>
            </BrowserRouter>
          </IntlProvider>
        </PersistGate>
      </Provider>
    );
  }
}

ReactDOM.render(<Root />, document.getElementById('root'));